import * as userActions from '../actions/Users';

const initialState = {
  users: [],
  offset: 0,
  limit: 10,
  totalCount: 7,
  detail: {
    favoriteShops: [],
    follows: [],
    followers: []
  },
  statuses: [
    {
      id: '',
      name: '未選択'
    },
    {
      id: 'AVAILABLE',
      name: '利用可能'
    },
    {
      id: 'SUSPENDED',
      name: '利用停止中'
    }
  ],
  error: false,
  status: 200,
  error_message: ''
};

const users = (state = initialState, action) => {
  switch (action.type) {
    case userActions.GET_USERS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case userActions.GET_USERS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case userActions.DOWNLOAD_USER_SUCCESS:
      return Object.assign({}, state, action.payload);
    case userActions.DOWNLOAD_USER_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case userActions.GET_USER_DETAIL_SUCCESS:
      return Object.assign({}, state, { detail: action.payload });
    case userActions.GET_USER_DETAIL_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case userActions.GET_BATCH_USER_SUCCESS:
      return Object.assign({}, state, { listBatchUser: action.payload });
    case userActions.GET_BATCH_USER_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case userActions.GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_SUCCESS:
      return Object.assign({}, state, {
        listMessageSentByAdmin: action.payload
      });
    case userActions.GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default users;
